'use client'

import { useSelectedTickerInfo } from '@/src/hooks/token-info/use-selected-ticker'
import { useTokenActions } from '@/src/hooks/token-info/use-token-actions'
import { useAccountsFilteredBalances } from '@/src/queries/hooks/balances'
import { BalanceSummariesAccordions } from '../balances'
import { Skeleton } from '../ui/skeleton'

function BalanceActivitySectionSkeleton() {
  return (
    <div className='flex flex-col gap-2 py-3'>
      <span className='text-primary text-xl font-semibold px-4'>
        Your balance
      </span>
      <div className='flex items-center gap-4 p-4 w-full'>
        <Skeleton className='size-12 rounded-full' />
        <div className='flex flex-col py-0.5 gap-1'>
          <div className='py-0.5'>
            <Skeleton className='w-24 h-4 rounded-[8px]' />
          </div>
          <div className='py-1'>
            <Skeleton className='w-16 h-3 rounded-[8px]' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default function BalanceActivitySection() {
  const { ticker } = useSelectedTickerInfo()
  const { pushRoute, prefetchRoute } = useTokenActions()
  const { balancesSummary: balances } = useAccountsFilteredBalances({
    ticker: ticker ?? undefined,
  })

  // With placeholderData, ticker should always be available during refetch - no need to check isLoading
  if (!ticker) {
    return <BalanceActivitySectionSkeleton />
  }

  return (
    <div className='flex flex-col gap-3 min-h-[145px]'>
      {balances.length > 0 && (
        <div className='flex flex-col py-3 gap-2'>
          <span className='text-primary text-xl font-semibold px-4'>
            Your balance
          </span>
          <div className='flex w-full'>
            <BalanceSummariesAccordions
              balancesSummary={balances}
              className='w-full'
              onClickBalance={({ chain_id, denom, ticker }) =>
                pushRoute({ chain_id, denom, ticker })
              }
              onHoverBalance={({ chain_id, denom, ticker }) => {
                prefetchRoute({ chain_id, denom, ticker })
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
